const Bag = ({ ...props }) => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.75 5C13.75 2.24301 11.507 0 8.75 0C5.99297 0 3.75 2.24301 3.75 5H0V16.875C0 18.6009 1.3991 20 3.125 20H14.375C16.1009 20 17.5 18.6009 17.5 16.875V5H13.75ZM8.75 1.25C10.8178 1.25 12.5 2.93223 12.5 5H5C5 2.93223 6.68223 1.25 8.75 1.25ZM16.25 16.875C16.25 17.9089 15.4089 18.75 14.375 18.75H3.125C2.09113 18.75 1.25 17.9089 1.25 16.875V6.25H3.75V8.125C3.75 8.4702 4.02984 8.75 4.375 8.75C4.72016 8.75 5 8.4702 5 8.125V6.25H12.5V8.125C12.5 8.4702 12.7798 8.75 13.125 8.75C13.4702 8.75 13.75 8.4702 13.75 8.125V6.25H16.25V16.875Z" fill="#464544"/>
    </svg>
  )
}

export default Bag
